import React from 'react';
import PropTypes from 'prop-types';
import { Card, Spinner } from 'react-bootstrap';

const STAT_FIELDS = [
  { key: 'TotalConnections', label: 'Total Connections' },
  { key: 'PendingConnections', label: 'Pending' },
  { key: 'AcceptedConnections', label: 'Accepted' },
  { key: 'ReceivedRequestConnections', label: 'Received Requests' },
  { key: 'RejectedRequests', label: 'Rejected' }
];

const AdminDashboardConnectionRequestsCard = ({ data, loading, error }) => {
  return (
    <Card className="h-md-100">
      <Card.Header className="pb-0">
        <h6 className="mb-0 mt-2">Connection Requests</h6>
      </Card.Header>
      <Card.Body className="pt-2 pb-3">
        {loading ? (
          <Spinner animation="border" size="sm" />
        ) : error ? (
          <p className="text-danger fs--1 mb-0">Unable to load metric</p>
        ) : (
          <ul className="list-unstyled mb-0">
            {STAT_FIELDS.map(({ key, label }, index) => (
              <li
                key={key}
                className={`d-flex justify-content-between align-items-baseline py-1 ${
                  index < STAT_FIELDS.length - 1
                    ? 'border-bottom border-200'
                    : ''
                }`}
              >
                <span className="text-600 fs--1">{label}</span>
                <span
                  className={`fw-semi-bold ${
                    key === 'TotalConnections'
                      ? 'fs-1 text-700'
                      : 'fs-0 text-800'
                  }`}
                >
                  {data?.[key] ?? 0}
                </span>
              </li>
            ))}
          </ul>
        )}
      </Card.Body>
    </Card>
  );
};

AdminDashboardConnectionRequestsCard.propTypes = {
  data: PropTypes.shape({
    TotalConnections: PropTypes.number,
    PendingConnections: PropTypes.number,
    AcceptedConnections: PropTypes.number,
    ReceivedRequestConnections: PropTypes.number,
    RejectedRequests: PropTypes.number
  }),
  loading: PropTypes.bool,
  error: PropTypes.object
};

export default AdminDashboardConnectionRequestsCard;
